/**
 * Check and clear invalid authentication tokens
 * This runs on app initialization to clean up old/invalid tokens
 */
export function checkAndClearInvalidAuth(): void {
  const token = localStorage.getItem('sso_token');
  
  if (token) {
    // Check if token looks malformed or is from before key regeneration
    try {
      // Basic JWT structure check
      const parts = token.split('.');
      if (parts.length !== 3) {
        console.warn('Malformed token detected, clearing auth data');
        clearAuthData();
        return;
      }
      
      // Check token age - if older than 1 hour, likely invalid after key regeneration
      const payload = JSON.parse(atob(parts[1]));
      const now = Math.floor(Date.now() / 1000);
      
      if (payload.exp && payload.exp < now) {
        console.warn('Expired token detected, clearing auth data');
        clearAuthData();
        return;
      }
      
      // If token was issued before Dec 8, 2025 13:00 UTC (key regeneration time)
      const keyRegenerationTime = 1733663700; // Dec 8, 2025 13:00 UTC
      if (payload.iat && payload.iat < keyRegenerationTime) {
        console.warn('Token issued before key regeneration, clearing auth data');
        clearAuthData();
      }
    } catch (error) {
      console.error('Error parsing token, clearing auth data:', error);
      clearAuthData();
    }
  }
}

function clearAuthData(): void {
  localStorage.removeItem('sso_token');
  localStorage.removeItem('sso_refresh_token');
  localStorage.removeItem('sso_user');
}
